export const SIMPLIAD_DATA = 'SIMPLIAD_DATA';
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const FORM_LOADER = 'FORM_LOADER';
export const REFRESH_USERDATA = 'REFRESH_USERDATA';
export const REFRESH_MEMBERDATA = 'REFRESH_MEMBERDATA';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const UPDATE_DASHBOARD = 'UPDATE_DASHBOARD';
export const CREATE_DASHBOARD = 'CREATE_DASHBOARD';
export const UPDATE_MEDIA = 'UPDATE_MEDIA';
export const SET_INPAGEFILTERS = 'SET_INPAGEFILTERS';
export const RESET_INPAGEFILTERS = 'RESET_INPAGEFILTERS';
export const USER_COMPARE_ANALYTICS = 'USER_COMPARE_ANALYTICS';
export const DATALINK_CONTENT = 'DATALINK_CONTENT';
export const CONNECTOR_CACHE_PUT = 'CONNECTOR_CACHE_PUT';
export const CONNECTOR_CACHE_PULL = 'CONNECTOR_CACHE_PULL';
export const UPDATE_ACCOUNTS = 'UPDATE_ACCOUNTS';
export const PAGE_CONTENT = 'PAGE_CONTENT';
export const USER_ACCOUNTS = 'USER_ACCOUNTS';
/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const COMPANY_SETTINGS = 'COMPANY_SETTINGS';
export const COMPANY_SETTINGS_SUCCESS = 'COMPANY_SETTINGS_SUCCESS';
export const COMPANY_SETTINGS_ERROR = 'COMPANY_SETTINGS_ERROR';
export const RESET_DATERANGES = 'RESET_DATERANGES';
export const NEW_ACTIVE_NETWORK = 'NEW_ACTIVE_NETWORK';
export const CONTENT_UPDATE = 'CONTENT_UPDATE';

export const LATEST_REQUEST = 'LATEST_REQUEST';
export const DOCUMENT_INITIAL_LOAD = 'DOCUMENT_INITIAL_LOAD';
export const INITIAL_PAGE_LOAD = 'INITIAL_PAGE_LOAD'; 
export const THEME_ACTIONS = 'THEME_ACTIONS';
export const SITE_SETTINGS = 'SITE_SETTINGS';
export const UPDATE_LOADER = 'UPDATE_LOADER';
export const RESET_LOADERS = 'RESET_LOADERS';
/* AUTH */
export const USER_REHYDRATE = 'USER_REHYDRATE';
export const USER_REHYDRATE_NETWORKS = 'USER_REHYDRATE_NETWORKS';
export const USER_REHYDRATE_ACCOUNTS = 'USER_REHYDRATE_ACCOUNTS';
export const USER_REHYDRATE_ACCOUNTS_SUCCESS = 'USER_REHYDRATE_ACCOUNTS_SUCCESS';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const REFRESH_AUTH_TOKEN_SUCCESS = 'REFRESH_AUTH_TOKEN_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const REFRESH_USER = 'REFRESH_USER';
export const REFRESH_USER_SUCCESS = 'REFRESH_USER_SUCCESS';
export const REFRESH_USER_ERROR = 'REFRESH_USER_ERROR';
export const FORM_CONTROLLER = 'FORM_CONTROLLER';
export const FORM_CONTROLLER_SUCCESS = 'FORM_CONTROLLER_SUCCESS';
export const FORM_CONTROLLER_ERROR = 'FORM_CONTROLLER_ERROR';
/* MENU */
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_SELECTED_VALUE = 'MENU_SELECTED_VALUE';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';
export const MENU_CHANGE_HAS_TOP_NAV_ITEM_STATUS = 'MENU_CHANGE_HAS_TOP_NAV_ITEM_STATUS';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  'MENU_CHANGE_HAS_SUB_ITEM_STATUS';

/* TODOAPP */
export const TODO_GET_LIST = 'TODO_GET_LIST';
export const TODO_GET_LIST_SUCCESS = 'TODO_GET_LIST_SUCCESS';
export const TODO_GET_LIST_ERROR = 'TODO_GET_LIST_ERROR';
export const TODO_GET_LIST_WITH_FILTER = 'TODO_GET_LIST_WITH_FILTER';
export const TODO_GET_LIST_WITH_ORDER = 'TODO_GET_LIST_WITH_ORDER';
export const TODO_GET_LIST_SEARCH = 'TODO_GET_LIST_SEARCH';
export const TODO_ADD_ITEM = 'TODO_ADD_ITEM';
export const TODO_ADD_ITEM_SUCCESS = 'TODO_ADD_ITEM_SUCCESS';
export const TODO_ADD_ITEM_ERROR = 'TODO_ADD_ITEM_ERROR';
export const TODO_SELECTED_ITEMS_CHANGE = 'TODO_SELECTED_ITEMS_CHANGE';

/* CHAT APP */
export const CHAT_GET_CONTACTS = 'CHAT_GET_CONTACTS';
export const CHAT_GET_CONTACTS_SUCCESS = 'CHAT_GET_CONTACTS_SUCCESS';
export const CHAT_GET_CONTACTS_ERROR = 'CHAT_GET_CONTACTS_ERROR';
export const CHAT_GET_CONVERSATIONS = 'CHAT_GET_CONVERSATIONS';
export const CHAT_GET_CONVERSATIONS_SUCCESS = 'CHAT_GET_CONVERSATIONS_SUCCESS';
export const CHAT_GET_CONVERSATIONS_ERROR = 'CHAT_GET_CONVERSATIONS_ERROR';
export const CHAT_ADD_MESSAGE_TO_CONVERSATION =
  'CHAT_ADD_MESSAGE_TO_CONVERSATION';
export const CHAT_CREATE_CONVERSATION = 'CHAT_CREATE_CONVERSATION';
export const CHAT_SEARCH_CONTACT = 'CHAT_SEARCH_CONTACT';
export const CHAT_CHANGE_CONVERSATION = 'CHAT_CHANGE_CONVERSATION';

/* SURVEY LIST APP */
export const SURVEY_LIST_GET_LIST = 'SURVEY_LIST_GET_LIST';
export const SURVEY_LIST_GET_LIST_SUCCESS = 'SURVEY_LIST_GET_LIST_SUCCESS';
export const SURVEY_LIST_GET_LIST_ERROR = 'SURVEY_LIST_GET_LIST_ERROR';
export const SURVEY_LIST_GET_LIST_WITH_FILTER =
  'SURVEY_LIST_GET_LIST_WITH_FILTER';
export const SURVEY_LIST_GET_LIST_WITH_ORDER =
  'SURVEY_LIST_GET_LIST_WITH_ORDER';
export const SURVEY_LIST_GET_LIST_SEARCH = 'SURVEY_LIST_GET_LIST_SEARCH';
export const SURVEY_LIST_ADD_ITEM = 'SURVEY_LIST_ADD_ITEM';
export const SURVEY_LIST_ADD_ITEM_SUCCESS = 'SURVEY_LIST_ADD_ITEM_SUCCESS';
export const SURVEY_LIST_ADD_ITEM_ERROR = 'SURVEY_LIST_ADD_ITEM_ERROR';
export const SET_FORM_DEFAULTS = 'SET_FORM_DEFAULTS';
export const SURVEY_LIST_SELECTED_ITEMS_CHANGE =
  'SURVEY_LIST_SELECTED_ITEMS_CHANGE';

/* SURVEY DETAIL APP */
export const SURVEY_GET_DETAILS = 'SURVEY_GET_DETAILS';
export const SURVEY_GET_DETAILS_SUCCESS = 'SURVEY_GET_DETAILS_SUCCESS';
export const SURVEY_GET_DETAILS_ERROR = 'SURVEY_GET_DETAILS_ERROR';
export const SURVEY_DELETE_QUESTION = 'SURVEY_DELETE_QUESTION';
export const SURVEY_SAVE = 'SURVEY_SAVE';

export const SERVICE_REQUEST = 'SERVICE_REQUEST';
export const CONTENT_MODAL = 'CONTENT_MODAL';
export const SERVICE_REQUEST_SUCCESS = 'SERVICE_REQUEST_SUCCESS';
export const SERVICE_REQUEST_ERROR = 'SERVICE_REQUEST_ERROR';
export const CLICKED = 'CLICKED';
export const USER_RESET_ANALYTICS = 'USER_RESET_ANALYTICS';
export const ACTIVE_NETWORK = 'ACTIVE_NETWORK';

export const ACTIVE_DASHBOARD = 'ACTIVE_DASHBOARD';
export const FLASH = 'FLASH';
export const ACTIVE_MENU_TREE = 'ACTIVE_MENU_TREE';
export const CURRENT_DATE_RANGE = 'CURRENT_DATE_RANGE';
export const USER_REHYDRATE_ANALYTICS = 'USER_REHYDRATE_ANALYTICS';
